import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { ActionButton } from '@fluentui/react';
import CumplimientoObligaciones from './CumplimientoObligacion/CumplimientoObligaciones';
import SidePanelViewEdPPartieComments from './SidePanelViewEdPPartieComments';
import SidePanelContractInformation from '../../../components/Products/sKPI/Board/_ComponentTypes/SG3_HEADER/SidePanelContractInformation';
import '@xyflow/react/dist/style.css';
import SidePanelAddEdPPartieComment from './SidePanelAddEdPPartieComment';
import moment from 'moment';
import { isNullOrEmpty, isNullUndefinedOrEmpty } from '../../../common/Helpers';
import { enum__AppElementType, enum__PRIVILEGE_APP, enum_ENUM_ESTADO_EP } from '../../../common/Dictionaries';
import MainAppContext from '../../../MainAppContext';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { __GetClientRoleCode } from '../../../common/CommonFuctions';

const InformationEdP = (props) => {
    const contextSite = useContext(MainAppContext);
    
    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_UserPropsKpi = null
    } = props;

    const {
        _edpPrepareHeader: edpPrepareHeader,
    } = useSelector((state) => state.edpPreparationState);


    const [isNewCommentPanelOpen, setIsNewCommentPanelOpen] = useState(false);
    const [isViewCommentsPanelOpen, setIsViewCommentsPanelOpen] = useState(false);
    const [isViewContractInfoPanelOpen, setIsViewContractInfoPanelOpen] = useState(false);

    const onViewContractInfoClick = () => {
        setIsViewContractInfoPanelOpen(true)
    }

    const onViewCommentsClick = () => {
        setIsViewCommentsPanelOpen(true)
    }

    const calcularFecha = (fecha) => {
        const day = moment(fecha).format('DD');
        const month = moment(fecha).format('MMMM').toLowerCase();
        const year = moment(fecha).format('yyyy');

        return `${day} ${t(`data-lang-lbl-${month}`)} ${year}`
    }

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header className='d-flex'>     
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-boxname-contractinformation')}</b></h4>
                    </Card.Title>
                    <ActionButton style={{position: "absolute", right: "0px"}} iconProps={{iconName: "View"}} text={t('data-lang-lbl-viewcontractinfo')} onClick={onViewContractInfoClick} />
                </Card.Header>
                <Card.Footer>
                    <Row>
                        <Col></Col>
                        <Col className='col-auto me-auto'>
                            <ActionButton className='me-1' iconProps={{iconName: "FileComment"}} text={t('data-lang-lbl-epcomments')} onClick={onViewCommentsClick} />
                        </Col>
                    </Row>
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <Row className='border rounded mb-3'>
                        <Col>
                            <Row><Col><b>{t('data-lang-lbl-contractname')}</b></Col></Row>
                            <Row><Col>{edpPrepareHeader.contracT_NAME}</Col></Row>
                        </Col>
                        <Col className='col-auto me-auto'>
                            <Row><Col><b>{t('data-lang-lbl-code')}</b></Col></Row>
                            <Row><Col>{edpPrepareHeader.contracT_CODE}</Col></Row>
                        </Col>
                        <Col className='col-auto me-auto'>
                            <Row><Col><b>{t('data-lang-lbl-comlabcompany')}</b></Col></Row>
                            <Row><Col>{edpPrepareHeader.contracT_EECC}</Col></Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row className='border'>
                                <Col className='my-auto'>
                                    <Row>
                                        <Col>{t('data-lang-lbl-lastepapproved2')}</Col>
                                        <Col><b>{edpPrepareHeader.ultimO_NRO_APROBADA}</b></Col>
                                    </Row>
                                </Col>
                                <Col className='border-start'>
                                    <Row>
                                        <Col>
                                        {
                                            contextSite.securityProps.l_products.some(product => product.toLowerCase() === enum__PRIVILEGE_APP.CO.toLowerCase()) &&
                                            <CumplimientoObligaciones
                                                inputParam_ElementId={inputParam_ElementId}
                                                inputParam_EdPId={inputParam_EdPId}
                                            />
                                        }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='border'>
                                <Col className='my-auto'>
                                    <Row>
                                        <Col>{t('data-lang-lbl-epnumber-large2')}</Col>
                                        <Col>
                                            <b>
                                                {
                                                    (edpPrepareHeader.estadO_ID == enum_ENUM_ESTADO_EP.PREPARACION && (((!isNullOrEmpty(edpPrepareHeader.meS_PREVIO))? !edpPrepareHeader.meS_PREVIO === "0000/00" : true) && edpPrepareHeader.nrO_EP === 1))
                                                    ? "-" : edpPrepareHeader.nrO_EP
                                                }
                                            </b>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col className='border-start'>
                                    <Row>
                                        <Col>
                                            <Row><Col>{t('data-lang-lbl-responsible')}</Col></Row>
                                            <Row><Col><b>{ edpPrepareHeader.autofacturacion === true ? __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'ATO') : edpPrepareHeader.responsable } Proveedor ({__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AEC')})</b></Col></Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='border'>
                                <Col className='my-auto'>
                                    <Row>
                                        <Col>{t('data-lang-lbl-epmonth')}</Col>
                                        <Col><b>{edpPrepareHeader.meS_EP}</b></Col>
                                    </Row>
                                </Col>
                                <Col className='border-start'>
                                    <Row>
                                        <Col className='border' style={{backgroundColor: "#d8d8d8"}}>{t('data-lang-lbl-collectionepperiod')}</Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='border'>
                                <Col className='my-auto'>
                                    <Row>
                                        <Col>{t('data-lang-lbl-currency')}</Col>
                                        <Col><b>{edpPrepareHeader.moneda}</b></Col>
                                    </Row>
                                </Col>
                                <Col className='border-start'>
                                    <Row>
                                        <Col className='border-end'>
                                            <Row><Col>{t('data-lang-lbl-datefrom')}</Col></Row>
                                            <Row><Col><b>{ !isNullUndefinedOrEmpty(edpPrepareHeader.fechA_DESDE) ? calcularFecha(edpPrepareHeader.fechA_DESDE) : ''}</b></Col></Row>
                                        </Col>
                                        <Col>
                                            <Row><Col>{t('data-lang-lbl-todate')}</Col></Row>
                                            <Row><Col><b>{ !isNullUndefinedOrEmpty(edpPrepareHeader.fechA_HASTA) ? calcularFecha(edpPrepareHeader.fechA_HASTA) : '-' }</b></Col></Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
                {
                    isNewCommentPanelOpen &&
                    <SidePanelAddEdPPartieComment inputParam_ElementId={inputParam_ElementId} inputParam_EdPId={inputParam_EdPId} inputParam_IsPanelOpen={isNewCommentPanelOpen} inputParam_SetterIsPanelOpen={setIsNewCommentPanelOpen} />
                }
                {
                    isViewCommentsPanelOpen &&
                    <SidePanelViewEdPPartieComments inputParam_UserPropsKpi={inputParam_UserPropsKpi} inputParam_ElementId={inputParam_ElementId} inputParam_EdPId={inputParam_EdPId} inputParam_IsPanelOpen={isViewCommentsPanelOpen} inputParam_SetterIsPanelOpen={setIsViewCommentsPanelOpen} />
                }
                {
                    isViewContractInfoPanelOpen &&
                    <SidePanelContractInformation contractId={edpPrepareHeader.contracT_ID} isPanelOpen={isViewContractInfoPanelOpen} setterIsPanelOpen={setIsViewContractInfoPanelOpen} />
                }
            </Card>
        </div>
    );
};

InformationEdP.propTypes = {
    inputParam_ElementId: PropTypes.number,
    inputParam_EdPId: PropTypes.number,
};

export default InformationEdP;